import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [shrunk, setShrunk] = useState(false);

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setShrunk(window.scrollY > 24);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={'site-header' + (shrunk ? ' is-shrunk' : '')}>
      <nav className="nav-bar">
        <Link to="/" className="brand-logo-link" aria-label="Layer & Co. — Home">
          <svg
            className="brand-logo-svg"
            width="160"
            height="58"
            viewBox="0 0 300 110"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <polyline points="18,32 18,10 40,10" fill="none" stroke="#1F8A8A" strokeWidth="3" strokeLinecap="square"/>
            <polyline points="282,32 282,10 260,10" fill="none" stroke="#1F8A8A" strokeWidth="3" strokeLinecap="square"/>
            <polyline points="18,78 18,100 40,100" fill="none" stroke="#1F8A8A" strokeWidth="3" strokeLinecap="square"/>
            <polyline points="282,78 282,100 260,100" fill="none" stroke="#1F8A8A" strokeWidth="3" strokeLinecap="square"/>
            <text x="150" y="45" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontSize="14" fontWeight="500" letterSpacing="6" fill="#13110F">LAYER</text>
            <rect x="60" y="51" width="180" height="1" fill="#1F8A8A" opacity="0.55"/>
            <text x="150" y="82" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontSize="32" fontWeight="400" fill="#13110F" letterSpacing="-1">&amp;Co.</text>
            <rect x="60" y="87" width="180" height="1" fill="#1F8A8A" opacity="0.55"/>
            <text x="150" y="98" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontSize="7" fontWeight="500" letterSpacing="4" fill="#7C766C">STUDIO</text>
          </svg>
        </Link>

        {/* Desktop links cluster */}
        <div className="nav-links">
          <NavLink to="/" end className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>Home</NavLink>
          <NavLink to="/services" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>Services</NavLink>
          <NavLink to="/live-previews" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>Live previews</NavLink>
          <NavLink to="/faq" className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}>FAQ</NavLink>
          <NavLink to="/contact" className="nav-cta">Start a project ↗</NavLink>
        </div>

        {/* Mobile CTA (sits next to logo on small screens) */}
        <NavLink to="/contact" className="nav-cta nav-cta-mobile">Start ↗</NavLink>
      </nav>

      {/* Mobile-only pill nav row */}
      <div className="nav-pill-row" role="navigation" aria-label="Primary mobile">
        <div className="nav-pill-track">
          <NavLink to="/" end className={({ isActive }) => 'nav-pill' + (isActive ? ' active' : '')}>Home</NavLink>
          <NavLink to="/services" className={({ isActive }) => 'nav-pill' + (isActive ? ' active' : '')}>Services</NavLink>
          <NavLink to="/live-previews" className={({ isActive }) => 'nav-pill' + (isActive ? ' active' : '')}>Previews</NavLink>
          <NavLink to="/faq" className={({ isActive }) => 'nav-pill' + (isActive ? ' active' : '')}>FAQ</NavLink>
        </div>
      </div>
    </header>
  );
}

export default Navbar;